// ==========================================================================
// groots Starter Kit
// Author: Globalia
// Licensed under the WTFPL license
// ==========================================================================

// Groots Core !! DO NOT DELETE !!
require('_groots.js');

// Display debug informations
window.groots.verbose = process.env.NODE_ENV === 'production' ? true : false;

// Require Groots JS-Plugins
window.groots.plugins = {
    grFormValidation:    require('grFormValidation/grFormValidation.js'),
    grNavigation:        require('grNavigation/grNavigation.js'),
    grObjectfitEmulator: require('grObjectfitEmulator/grObjectfitEmulator.js'),
    grSVGInliner:        require('grSVGInliner/grSVGInliner.js')
}; // Remove plugins you don't use from this array to not include them in your project

// 3rd party plugins
require('slick-carousel');

// ==========================================================================
// Custom Scripts
// ==========================================================================

require('./components/_forms.js');
require('./components/_navigation.js');
require('./components/_carousel.js');
require('./components/_category-bar.js');
require('./components/_videos.js');
